import getBuiltIn$1 from '../internals/get-built-in.js';
import setToStringTag$1 from '../internals/set-to-string-tag.js';

var getBuiltIn = getBuiltIn$1;
var setToStringTag = setToStringTag$1;
var DOM_EXCEPTION = 'DOMException';
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);
